import hero from '../../resources/js/module/hero'
import {initModal} from '../../resources/js/module/modal'
import Swiper from 'swiper/bundle'
import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Observer from 'gsap/Observer'
import 'swiper/css/bundle'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Observer)

$(document).ready(function () {
  hero()
  initModal()

  const sliderWrapper = $('.tr-slider__wrapper')
  if (sliderWrapper) {
    new Swiper('.tr-slider__wrapper', {
      slidesPerView: 'auto',
      spaceBetween: 32,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      initialSlide: 1,
      centeredSlides: true,
      pagination: {
        el: '.custom-swiper-pagination',
        bulletClass: 'custom-swiper-pagination__bullet',
        clickable: true,
      },
      navigation: {
        nextEl: '.wrapper-slider-navigation-btn--next',
        prevEl: '.wrapper-slider-navigation-btn--prev',
      },
      breakpoints: {
        1024: {
          freeMode: true,
        },
      },
    })
  }
  sliderWrapper.find('.tr-slider__item-slide').hover(function () {
    gsap.to($(this), {y: '-20'})
    sliderWrapper.find('.tr-slider__item-slide').addClass('blur')
    $(this).removeClass('blur')
  }, function () {
    gsap.to($(this), {y: '0'})
    sliderWrapper.find('.tr-slider__item-slide').removeClass('blur')
  })

  if (window.innerWidth >= 992) {
    ScrollTrigger.matchMedia({
      '(min-width: 1300px)': () => {
        const tl = gsap.timeline({
          paused: true,
          stagger: 0.5,
        })
        const tl1 = gsap.timeline({
          paused: true,
        }).to('.tr-info-tire__container', {y: -300})

        gsap.utils.toArray('.tr-info-tire__text-item').forEach((pinnedContent) => {
          tl
            .fromTo(pinnedContent, {y: 20, autoAlpha: 0}, {y: 0, autoAlpha: 1})
            .to(pinnedContent, {
              onComplete: function () {
                $(pinnedContent).addClass('active')
              },
            })
        })

        ScrollTrigger.create({
          trigger: '.tr-info-tire',
          scrub: true,
          pin: true,
          start: 'top top',
          end: '50%',
          // markers: true,
        })

        ScrollTrigger.create({
          trigger: '.tr-info-tire',
          scrub: true,
          // pin: true,
          start: 'top center',
          end: '80%',
          animation: tl,
          // markers: true,
        })

        ScrollTrigger.create({
          trigger: '.tr-info-tire',
          scrub: true,
          start: 'top top',
          end: '100%',
          animation: tl1,
          markers: false,
        })
      },
      '(max-width: 1299px)': () => {
        const tl = gsap.timeline({
          defaults: {
            duration: 0.4,
          },
        })

        const items = gsap.utils.toArray('.tr-info-tire__text-item')
        // let activeAnimate = false;
        let animationIndex = -1
        ScrollTrigger.create({
          trigger: '.tr-info-tire',
          pin: true,
          start: 'top top',
          scrub: true,
          marker: true,
          end: '+=200%',
          anticipatePin: 1,
          id: 'trigger-section',
          onUpdate: (self) => {
            const numAnimations = items.length
            const scrollPercent = self.progress * 100
            const newIndex = Math.floor(scrollPercent / (100 / numAnimations))
            if (newIndex !== animationIndex) {
              animationIndex = newIndex
              const currentEl = $(items[animationIndex]).length >= 1 ? $(items[animationIndex]) : $(items[items.length - 1])
              if (currentEl.length >= 1 && !currentEl.hasClass('active-info-block')) {
                $('.tr-info-tire__text-item.active-info-block').removeClass('active-info-block')
                currentEl.addClass('active-info-block')
                tl.to(items, {opacity: 0})
                tl.to(currentEl, {
                  opacity: 1,
                })
              }
            }
          },
        })
      },
    })
  }
})

ScrollTrigger.matchMedia({
  '(min-width: 560px)': function () {
    gsap.timeline({
      scrollTrigger: {
        trigger: $('.tr-ab-tires-conditions-characteristics'),
        markers: false,
        start: 'top center',
        end: 'top center',
        onEnter: () => {
          const timeLine = gsap.timeline()
          $('.tr-ab-tires-conditions-characteristics__item').each(function () {
            timeLine
              .to($(this).find('.tr-ab-tires-conditions-characteristics__item-title'), {autoAlpha: 1}, '-=0.1')
              .to($(this).find('.tr-ab-tires-conditions-characteristics__item-icon'), {autoAlpha: 1}, '-=0.5')
              .to($(this).find('.line'), {height: 258})
          })
        },
      },
    })
  },

  // small
  '(max-width: 599px)': function () {
    // anim
    gsap.timeline({
      scrollTrigger: {
        trigger: $('.tr-ab-tires-conditions-characteristics'),
        markers: false,
        start: 'top center',
        end: 'top center',
        onEnter: () => {
          const timeLine = gsap.timeline()
          $('.tr-ab-tires-conditions-characteristics__item').each(function () {
            timeLine
              .to($(this).find('.tr-ab-tires-conditions-characteristics__item-title'), {autoAlpha: 1}, '-=0.1')
              .to($(this).find('.tr-ab-tires-conditions-characteristics__item-icon'), {autoAlpha: 1}, '-=0.5')
              .to($(this).find('.line'), {height: 115})
          })
        },
      },
    })
  },

})

